import { useState } from 'react';
import html2canvas, { Options } from 'html2canvas';

interface screenshotProps {
  type: string;
  quality: number;
  canvasOptions: Partial<Options>;
}

const useScreenshot = ({ type, quality, canvasOptions }: screenshotProps) => {
  const [image, setImage] = useState('');
  const [error, setError] = useState(null);

  const takeInstagramScreenshot = (
    node: HTMLElement,
    width?: number,
    height?: number,
  ) => {
    if (!node) {
      throw new Error('You should provide correct html node.');
    }

    return html2canvas(node, canvasOptions)
      .then(canvas => {
        const croppedCanvas = document.createElement('canvas');
        const croppedCanvasContext = croppedCanvas.getContext('2d');

        const cropPositionTop = 0;
        const cropPositionLeft = 0;

        croppedCanvas.width = width ?? canvas.width;
        croppedCanvas.height = height ?? canvas.height;

        croppedCanvasContext!.drawImage(
          canvas,
          cropPositionTop,
          cropPositionLeft,
          croppedCanvas.width,
          croppedCanvas.height,
        );

        const base64Image = croppedCanvas.toDataURL(type, quality);

        setImage(base64Image);
        return base64Image;
      })
      .catch(e => setError(e));
  };

  return { image, takeInstagramScreenshot, error };
};

const createFileName = (extension = '', ...names: string[]) => {
  if (!extension) {
    return '';
  }
  return `${names.join('')}.${extension}`;
};

function dataURItoBlob(dataURI: string) {
  var byteString = atob(dataURI.split(',')[1]);

  var mimeString = dataURI
    .split(',')[0]
    .split(':')[1]
    .split(';')[0];

  var ab = new ArrayBuffer(byteString.length);

  var ia = new Uint8Array(ab);

  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  var blob = new Blob([ab], { type: mimeString });
  return blob;
}

export { useScreenshot, createFileName, dataURItoBlob };
